import { useLocale } from "../contexts/LocaleContext";

export function ArtPage() {
  const { t } = useLocale();

  return (
    <section className="wrapper gallery">
      <div className="row">
        <div className="col-full centered">
          <h1>{t("art.title")}</h1>

          <p>{t("art.goal")}</p>

          <aside className="note" role="note">
            <p>
              <strong>{t("art.noteTitle")}</strong> {t("art.note")}
            </p>
            <img src="/static/img/erdkugel.jpg" alt={t("art.globeAlt")} />
          </aside>

          <h2 id="einzelne-kunstwerke">{t("art.singleTitle")}</h2>
          <p>{t("art.singleText")}</p>
          <img src="/static/img/platz.jpg" alt={t("art.placeAlt")} />
          <img src="/static/img/collage.jpg" alt={t("art.collageAlt")} />

          <h2 id="fertige-kunstwerke">{t("art.finishedTitle")}</h2>
          <p>{t("art.finishedText")}</p>
          <img src="/static/img/stadt.jpg" alt={t("art.cityAlt")} />
          <img src="/static/img/collage2.jpg" alt={t("art.collageAlt")} />

          <h2 id="kunstwerke-finden">{t("art.findTitle")}</h2>
          <p>{t("art.findText1")}</p>
          <p>{t("art.findText2")}</p>
        </div>
      </div>
    </section>
  );
}
